<template>
  <div class="last-consultation flex pb-10">
    <div class="flex-1">
      <h2 class="flex mb-5">
        <!-- <span class="text-dark font-semibold text-2xl"><span class="text-primary">最新</span>资讯</span>
        <div class="ml-1">
          <span class=" rounded-full bg-[#F25B3A] font-semibold text-white text-xs px-2 inline-block ">NEW</span>
        </div> -->
        <span class="text-dark font-semibold text-2xl">行业资讯</span>
      </h2>
      <div class="mr-11">
        <transition-group enter-active-class="animate__animated animate__fadeIn">
          <ConsultationItem class="siblings:mt-11" v-for="item in informations" :key="item.no" :consultation="item" />
        </transition-group>
      </div>
      <loading-more-btn :pagination="pagination" :isLoading="isLoading" @onLoadMore="onLoadMore"/>
      <!-- <div v-if="pagination.page_index < pagination.total_page" class="footer flex justify-center mt-16 mb-4">
        <el-button class="load-btn" type="info" @click="onLoadMore" :loading="isLoading">查看更多信息</el-button>
      </div> -->
    </div>
    <ConsultationAside class="w-[310px] flex-none"/>
  </div>
</template>
<script>
import ConsultationItem from "@/views/company/ConsultationItem.vue";
import ConsultationAside from "@/views/company/ConsultationAside.vue";
import LoadingMoreBtn from '@/views/company/LoadingMoreBtn.vue';
// import useRequest from "~/composables/useRequest";
import usePagination from "~/composables/usePagination";
import { getInformationList } from "~/services/company";
import { ref, useFetch } from "@nuxtjs/composition-api";

export default {
  name: "IndexLatestConsultation",
  components: { ConsultationItem, ConsultationAside, LoadingMoreBtn },
  setup() {
    //   const {} = useRequest(() => {})
    const informations = ref([]);
    const {
      execute,
      pagination,
      isLoading,
    } = usePagination(
      ({ page_index, page_size }) =>
        getInformationList({
          page_index,
          page_size,
        }),
      undefined,
      {
        immediate: false,
      }
    );
    const { fetch } = useFetch(async () => {
      let data = await execute(0, pagination);
      informations.value = informations.value.concat(data.list);
      // console.log(informationData.value);
    });
    pagination.page_size = 6;
    function onLoadMore() {
      pagination.page_index += 1;
      fetch();
    }
    return {
      informations,
      isLoading,
      pagination,

      onLoadMore,
    };
  },
};
</script>
<style lang="scss" scoped>

// .load-btn {
//   @apply bg-white border-[#1F2129] rounded text-dark w-[218px] h-[44px] transition-colors;

//   &:hover,
//   &:focus {
//     @apply bg-[#E6E8F2] border-[#E6E8F2] opacity-80;
//   }

//   &:active {
//     @apply opacity-95;
//   }
// }

</style>